import DoNotDisturbAltOutlinedIcon from "@mui/icons-material/DoNotDisturbAltOutlined";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

const NoDataAvailableError = () => {
  const { t } = useTranslation(["common", "orders"]);
  const theme = useTheme();
  return (
    <Box
      data-testid="no-data-available-error"
      sx={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        color: theme.tokens.FuelColorTextTertiary,
        padding: theme.tokens.FuelSpacing8,
        height: "90%",
      }}
    >
      <Typography
        sx={{
          textAlign: "center",
          fontWeight: theme.tokens.FuelFontWeightRegular,
          fontSize: theme.tokens.FuelFontSizeMd,
          display: "flex",
          flexDirection: "column",
          gap: theme.tokens.FuelSpacing2,
          alignItems: "center",
        }}
        data-testid="no-row-available-error"
      >
        <DoNotDisturbAltOutlinedIcon
          sx={{
            width: theme.tokens.FuelFontSizeHeading2,
            height: theme.tokens.FuelFontSizeHeading2,
            marginBottom: "-4px",
            marginRight: theme.tokens.FuelSpacing1,
          }}
        />
        {t("error.noDataAvailable")}
      </Typography>
    </Box>
  );
};

export default NoDataAvailableError;
